interface AdvisorImageProps {
  src: string;
  alt?: string;
  /** Size in pixels. Defaults to 80. */
  size?: number;
}

export default function AdvisorImage({ src, alt = 'Advisor', size = 80 }: AdvisorImageProps) {
  return (
    <div
      className="flex-shrink-0 overflow-hidden rounded-full border-[3px] border-primary-600"
      style={{ width: size, height: size }}
    >
      <img src={src} alt={alt} className="h-full w-full object-cover" />
    </div>
  );
}
